import FetchHelpers from '../../../utils/FetchHelpers';
import formUrl from '../../../utils/routes';

export default {
  load(fastCashId) {
    const url = formUrl(`/api/v1/admin/fast_cash/${fastCashId}/logs`);

    return FetchHelpers.get(url);
  },
};
